import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../button-reusable/button-reusable';

export type PopupSize = 'sm' | 'md' | 'lg' | 'xl3' | 'xl' | 'xxl' | 'full' | 'full80';

@Component({
  selector: 'app-popup-reusable',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './popup-reusable.html',
  styleUrl: './popup-reusable.css',
})
export class PopupReusable {
  @Input() isOpen = false;
  @Input() showDefaultFooter = true;
  @Input() maxWidthClass: string | null = null;
  @Input() maxHeightClass: string | null = null;
  @Input() dialogPanelClass = '';
  @Input() bodyOverflowVisible = false;
  @Input() bodyPaddingClass = 'px-6 py-5';
  @Input() closeOnBackdrop = false;
  @Input() showCloseButton = true;
  @Input() size: PopupSize = 'sm';
  @Output() close = new EventEmitter<void>();

  get dialogWidthClass(): string {
    if (this.maxWidthClass?.trim()) {
      return this.maxWidthClass;
    }

    switch (this.size) {
      case 'sm':
        return 'max-w-md';
      case 'md':
        return 'max-w-lg';
      case 'lg':
        return 'max-w-2xl';
      case 'xl3':
        return 'max-w-3xl';
      case 'xl':
        return 'max-w-4xl';
      case 'xxl':
        return 'max-w-6xl';
      case 'full':
        return 'max-w-[96vw]';
      case 'full80':
        return 'max-w-3xl';
      default:
        return 'max-w-xl';
    }
  }

  get dialogHeightClass(): string {
    if (this.maxHeightClass?.trim()) {
      return this.maxHeightClass;
    }
    if (this.size === 'full80') {
      return 'h-[90dvh]';
    }
    return 'max-h-[calc(100dvh-2rem)]';
  }

  onBackdropClick(event: MouseEvent): void {
    if (this.closeOnBackdrop && event.target === event.currentTarget) {
      this.close.emit();
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
